import { useNavigate } from "react-router";
import error_background from "../../assets/images/main/error_background.svg";
import error400 from "../../assets/images/main/error400.svg";
import error403 from "../../assets/images/main/error403.svg";
import error404 from "../../assets/images/main/error404.svg";
import error502 from "../../assets/images/main/error502.svg";
import error503 from "../../assets/images/main/error503.svg";
// @ts-ignore
import error429 from "../../assets/images/main/error429.png";
import accessDenied from "../../assets/images/main/accessDenied.svg";
import { ErrorPageContainer } from "./ErrorPage.style";

// Map error codes to their corresponding image imports
const errorImages: Record<string | number, string> = {
  400: error400,
  403: error403,
  404: error404,
  429: error429,
  500: error503,
  502: error502,
  503: error503,
  200: accessDenied,
};

interface ErrorPageProps {
  error: {
    code?: string | number;
    message?: string;
    response?: {
      status?: number;
    };
   
  };
}


const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const navigate = useNavigate();
  // const containerStyle = {
  //   height: error?.height || '100%', // Default to 100% if not provided
  //   width: error?.width || '100%',   // Default to 100% if not provided
  // };
  const handleGoBackHome = (status: string | number) => {
    if (
      status === "204" ||
      status === "400" ||
      status === "402" ||
      status === "404" ||
      status === "500"
    ) {
      navigate(-1);
    } else {
      // Navigate based on the status code if not 404
      const route = "/dashboard";
      window.location.href = route;
    }
  };
  const errorImage = error?.code ? errorImages[error.code] : error503; // Default to error500 if status is not mapped
  return error?.code != "ERR_NETWORK" ? (
    <ErrorPageContainer  >
      <img src={error_background} alt="error_background" />
      <img src={errorImage} className="error__image" />
      {/* <ErrorCode name={error?.response?.status} /> */}
      <p className="error__title">{error?.message}</p>
      {error?.code != 502 && error?.code != 503 && (
        <button
          className="common__button"
          onClick={() => handleGoBackHome(error?.code ?? "500")}
        >
          Go back Home
        </button>
      )}
    </ErrorPageContainer>
  ) : (
    <ErrorPageContainer>
      <img src={error_background} alt="error_background" />
      <img src={error503} className="error__image" />
      {/* <ErrorCode name={"500"} /> */}
      <p className="error__title">
        Uh-oh, our server's taking a coffee break. It'll be back to ringing up
        sales soon!
      </p>
      <button
        className="common__button"
        onClick={() => handleGoBackHome("500")}
      >
        Go back Home
      </button>
    </ErrorPageContainer>
  );
};

export default ErrorPage;
